<ul class="files">
  <li *ngFor="let file of attachments | imagesOnly; let i = index">
    <img
      src="{{ url + '/file?f=' + file.thumburl }}"
      width="80"
      (click)="open(i)"
      *ngIf="file.thumburl && file.thumburl != ''"
    />
    <img
      src="{{ url + '/file?f=' + file.filename }}"
      width="80"
      (click)="open(i)"
      *ngIf="!file.thumburl || file.thumburl == ''"
    />
  </li>
</ul>
<ul class="files">
  <li *ngFor="let file of attachments | notImageOnly; let i = index">
    <a
      href="{{ url + '/file?f=' + file.filename }}"
      class="mr-4"
      target="_blank"
      *ngIf="!file.thumburl"
    >
      <i class="fas fa-file fa-fw"></i>
      {{
        file.remarks && file.remarks.trim() != ''
          ? file.remarks
          : file.fileurl && file.fileurl != ''
            ? file.fileurl
            : file.name && file.name != ''
              ? file.name
              : 'File ' + (i + 1)
      }}
    </a>
  </li>
</ul>
